import{gql as e}from"@apollo/client";const t=e`
  query getImpersonateUserLink($projectId: String!) {
    project {
      getProject(projectId: $projectId) {
        settings {
          impersonateUserLink
        }
      }
    }
  }
`;export{t as GET_IMPERSONATE_USER_LINK_QUERY};
//# sourceMappingURL=useGetImpersonateUserLink.graphql.js.map
